/**
 * Parse any partnumber provided
 * @param {any} dat - the selected part creator
 * @param {any} val - the text of the part number
 * @param {any} val - the text of the part number
 * @param {any} self - reference to the react component
 */
export default async function parsePN(dat, val, self) {

    let noprofile = false;
    
    val = val.toUpperCase();
    self.parsersran = true;

    let _val = val.startsWith('M/') ? val.substring(2) : val;
    _val = _val.startsWith('M8/') ? _val.substring(3) : _val;
    _val = _val.startsWith('P25/') ? _val.substring(4) : _val;

    let arvals = val.split('-');
    let arvals2 = val.split('/');

    // Figure out which part creator to run
    if (!self.state.selected) {

        if (_val.startsWith('HSCE')) {
            noprofile = await setCategory(self, 'HSCE');
        }
        else if (_val.startsWith('HSC')) {
            noprofile = await setCategory(self, 'HSC');
        }

        else if (_val.startsWith('XE')) {
            noprofile = await setCategory(self, 'XE');
        }
        // ??
        else if (_val.startsWith('FLX')) {
            noprofile = await setCategory(self, 'FLX');
        }
        else if (_val.startsWith('DP')) {
            noprofile = await setCategory(self, 'PProbe');
        }
        else if (_val.startsWith('DR')) {
            noprofile = await setCategory(self, 'Prox Driver');
        }
        else if (_val.startsWith('ACCESS')) {
            noprofile = await setCategory(self, 'Other');
        }
        else if (_val.startsWith('CB') && arvals.length == 1 && arvals2.length == 2) {
            noprofile = await setCategory(self, 'Other');
        }
        else if (_val.startsWith('CB9')) {
            noprofile = await setCategory(self, 'Other');
        }
        else if (_val.startsWith('CBR')) {
            noprofile = await setCategory(self, 'Other');
        }
        else if (_val.startsWith('CB') || _val.startsWith('TMC')) {
            noprofile = await setCategory(self, 'Cable');
        }
        else if (_val.startsWith('SCC')) {
            noprofile = await setCategory(self, 'Other');
        }
        else if (_val.startsWith('SC3')) {
            noprofile = await setCategory(self, 'SC3');
        }
        else if (_val.startsWith('MVR')) {
            noprofile = await setCategory(self, 'MVR');
        }
        else if (_val.startsWith('SCE') && _val.charAt(5)=='5') {
            noprofile = await setCategory(self, 'SCE Copy');
        }
        else if (_val.startsWith('SCE')) {
            noprofile = await setCategory(self, 'SCE Copy');
        }

        else if (_val.startsWith('PXD')) {
            noprofile = await setCategory(self, 'PXD');
        }
        else if (_val.startsWith('PXE')) {
            noprofile = await setCategory(self, 'PXE');
        }
        else if (_val.startsWith('SCD15')) {
            noprofile = await setCategory(self, 'SCD Copy');
        }
        else if (_val.startsWith('SCD')) {
            noprofile = await setCategory(self, 'SCD Copy');
        }

        else if (_val.startsWith('IS')) {
            noprofile = await setCategory(self, 'Other');
        }
        else if (_val.startsWith('JB9') || _val.startsWith('JBA')) {
            noprofile = await setCategory(self, 'JB Accessory');
        }
        else if (_val.startsWith('SSB-MOD') || _val.startsWith('DSB-MOD') ||
            _val.startsWith('TSB-MOD') || _val.startsWith('MMX-MOD')) {
            noprofile = await setCategory(self, 'Box Module');
        }
        else if (_val.startsWith('USB') || _val.startsWith('MH') || _val.startsWith('CP') ||
            _val.startsWith('CM') || _val.startsWith('CK') || _val.startsWith('CA') ||
            _val.startsWith('CTC') || _val.startsWith('JCI') ||
            _val.startsWith('TM') || _val.startsWith('VE101-1A') || _val.startsWith('VE102-1A')) {
            noprofile = await setCategory(self, 'Other');
        }
        else if (
            _val.startsWith('JB') || _val.startsWith('SB') ||
            _val.startsWith('DSB') || _val.startsWith('TSB') ||
            _val.startsWith('CT') || _val.startsWith('TCT') ||
            _val.startsWith('CR') || _val.startsWith('CRHT') || _val.startsWith('MMX') || _val.startsWith('MX')) {
            noprofile = await setCategory(self, 'Box');
        }
        else if (_val.startsWith('SSB9') && (val.split('-')[1].match(/[a-zA-Z]+/g) == 'B')) {
            noprofile = await setCategory(self, 'Barrier Enclosures');
        }
        else if (_val.startsWith('SSB')) {
            noprofile = await setCategory(self, 'Box');
        }

        else if (
            _val.startsWith('AC') || _val.startsWith('TA') || _val.startsWith('TC') ||
            _val.startsWith('WT') || _val.startsWith('VE') || _val.startsWith('TR') ||
            _val.startsWith('VT') || _val.startsWith('TR') || _val.startsWith('MA') ||
            _val.startsWith('UEB') || _val.startsWith('UEA') || _val.startsWith('MEB') ||
            _val.startsWith('MCB') || _val.startsWith('BSFA') || _val.startsWith('TK') ||
            _val.startsWith('TX') ||
            _val.startsWith('TCEB') ||
            _val.startsWith('TRCA') || _val.startsWith('TREA') || _val.startsWith('TSFA') ||
            _val.startsWith('TEB') || _val.startsWith('TCB') || _val.startsWith('TEA') ||
            _val.startsWith('TCA')) {
            noprofile = await setCategory(self, 'Sensor');
        }
        else if (_val.startsWith('LPT')) {
            noprofile = await setCategory(self, 'LP Sensor v2');
        }
        else if (_val.startsWith('LP')) {
            noprofile = await setCategory(self, 'LP Sensor');
        }
        else if (_val.startsWith('HVLP')) {
            noprofile = await setCategory(self, 'LP Sensor');
        }

        else if (_val.startsWith('DD') || _val.startsWith('DR') || _val.startsWith('dd')) {
            noprofile = await setCategory(self, 'Prox Driver');
        }
        //??
        else if (_val.startsWith('DM937') || _val.startsWith('DM938')) {
            noprofile = await setCategory(self, 'Other');
        }
        else if (_val.startsWith('DM92000')) {
            noprofile = await setCategory(self, 'Prox Mount DM92000');
        }
        else if (_val.startsWith('DM95000')) {
            noprofile = await setCategory(self, 'Prox Mount DM95000');
        }
        else if (_val.startsWith('DM7200')) {
            noprofile = await setCategory(self, 'DM7200 Prox Mount');
        }
        else if (_val.startsWith('DT902')) {
            noprofile = await setCategory(self, 'DT902 Field Calibrator Unit');
        }
        else if (_val.startsWith('DM') && arvals[0].length==6) {
            noprofile = await setCategory(self, 'NPT');
        }
        else if (_val.startsWith('DM')) {
            noprofile = await setCategory(self, 'Prox Mount');
        }
        else if (_val.startsWith('DC')) {
            noprofile = await setCategory(self, 'Prox Cable');
        }
        //??
        else if (_val.startsWith('RXE') && _val.length == 14) {
            noprofile = await setCategory(self, 'RXE');
        }
        else if (_val.startsWith('MVR') || _val.startsWith('RXE') || _val.startsWith('PMX')) {
            noprofile = await setCategory(self, 'Relay System');
        }
        else if (_val.startsWith('PM')) {
            noprofile = await setCategory(self, 'PM');
        }

        else if (_val.startsWith('PD') || _val.startsWith('RE')) {
            noprofile = await setCategory(self, 'Relay');
        }
        else if (_val.startsWith('SC')) {
            noprofile = await setCategory(self, 'SC');
        }
        else if (_val.startsWith('VN')) {
            noprofile = await setCategory(self, 'Vibration Pole');
        }
        else if (_val.startsWith('WSK')) {
            noprofile = await setCategory(self, 'WSK');
        }
        else if (_val.startsWith('WS') && arvals[1].includes("PK")) {
            noprofile = await setCategory(self, 'Other');
        }
        else if (_val.startsWith('WS')) {
            noprofile = await setCategory(self, 'WS');
        }
        else if (_val.startsWith('PL-PRICING')) {
            noprofile = await setCategory(self, 'Other');
        }
        else
        {
            noprofile = true;
        }
        dat = self.state.data.filter(x => x.newid != self.state.selected)[0];

    }

    if (noprofile) return true;

    // Product line specific parsing
    if (_val.startsWith('HSCE')) {
        //#region XE Script
        let main = 'HSCE';
        let material = '';
        let power = '';
        let numchannel = '';
        let entry = '';
        let exit = '';

        let arval = val.split('-');
        try {
            material = arval[0][4];
            power = arval[0][5];
            numchannel = arval[0][6]+arval[0][7];
            entry = arval[1][0];
            exit = arval[1][1];
        }
        catch { }

        self.setState((s, p) => {
            self.setOptionValX(dat.id, s, '', 'HSCE', main, '');
            self.setOptionValX(dat.id, s, '', 'Enclosure Material', material, '');
            self.setOptionValX(dat.id, s, '', 'Power', power, '');
            self.setOptionValX(dat.id, s, '', 'Number of Installed HSC100s', numchannel, '');
            self.setOptionValX(dat.id, s, '', 'Enclosure Entry', entry, '');
            self.setOptionValX(dat.id, s, '', 'Output', exit, '');

            return self.reCalcOutput(dat.id, s, p, '', '', '', '');
        });
        //#endregion
    } else if (_val.startsWith('HSC')) {
        //#region XE Script
        let main = 'HSC100';
        let Power = '';
        let InputGain = '';
        let MixingFrequency = '';

        let arval = val.split('-');
        try {
            Power = arval[1];
            InputGain = arval[2];
            MixingFrequency = arval[3];
        }
        catch { }

        self.setState((s, p) => {
            self.setOptionValX(dat.id, s, '', 'HSC', main, '');
            self.setOptionValX(dat.id, s, '', 'Power', Power, '');
            self.setOptionValX(dat.id, s, '', 'Input Gain', InputGain, '');
            self.setOptionValX(dat.id, s, '', 'Mixing Frequency', MixingFrequency, '');

            return self.reCalcOutput(dat.id, s, p, '', '', '', '');
        });
        //#endregion
    }
    else if (_val.startsWith('XE')) {
        //#region XE Script
        let xe = 'XE';
        let boxsize = '';
        let boxmtl = '';
        let boxout = '';
        let boxcode = '';
        let temp = '_';
        let numchannel = '';
        let entry = '';
        let exit = '';
        let ether = '';

        val = val.substring(2);
        let arval = val.split('-');
        try {
            if (arval[0].endsWith('T')) temp = 'T'
            arval[0] = arval[0].replaceAll('T', '');
            boxcode = arval[0];
            numchannel = arval[1];
            entry = arval[2][0];
            exit = arval[2][1];
            ether = arval[3];
        }
        catch { }

        self.setState((s, p) => {
            self.setOptionValX(dat.id, s, '', 'XE', xe, '');
            self.setOptionValX(dat.id, s, '', 'Box Code', boxcode, '');
            self.setOptionValX(dat.id, s, '', 'Temperature', temp, '');
            self.setOptionValX(dat.id, s, '', 'Number Of Channels', numchannel, '');
            self.setOptionValX(dat.id, s, '', 'Enclosure Entry', entry, '');
            self.setOptionValX(dat.id, s, '', 'Enclosure Exit', exit, '');
            self.setOptionValX(dat.id, s, '', 'Ethernet Option', ether, '');

            return self.reCalcOutput(dat.id, s, p, '', '', '', '');
        });
        //#endregion
    }
    else if (_val.startsWith('JB9') || _val.startsWith('JBA')) {
        var JunctionBoxAccessory = '';

        //let arval = val.split('-');

        try {
            JunctionBoxAccessory = val;
        }
        catch { }

        self.setState((s, p) => {
            self.setOptionValX(dat.id, s, '', 'Junction Box Accessory', JunctionBoxAccessory, '');

            return self.reCalcOutput(dat.id, s, p, '', '', '', '');
        });
    }
    else if (_val.startsWith('FLX')) {
        var Case = '';
        var PowerSupply = '';
        var DinRails = '';
        var Conduits = '';
        var GreyCordgrips = '';
        var BlackCordgrips = '';
        var StainlessCordgrips = '';

        let arval = val.split('-');

        try {
            Case = arval[0].match(/\d+/g);
            if (arval[0].length <= 7) {
                PowerSupply = '_';
            }
            else {
                PowerSupply = arval[0].charAt(7);
            }
            DinRails = arval[1];
            Conduits = arval[2];
            GreyCordgrips = arval[3].charAt(0);
            BlackCordgrips = arval[3].charAt(1);
            StainlessCordgrips = arval[3].charAt(2);
        }
        catch { }

        self.setState((s, p) => {
            self.setOptionValX(dat.id, s, '', 'Case', Case, '');
            self.setOptionValX(dat.id, s, '', 'Power Supply', PowerSupply, '');
            self.setOptionValX(dat.id, s, '', 'Din Rails', DinRails, '');
            self.setOptionValX(dat.id, s, '', 'Conduits', Conduits, '');
            self.setOptionValX(dat.id, s, '', 'Grey Cordgrips', GreyCordgrips, '');
            self.setOptionValX(dat.id, s, '', 'Black Cordgrips', BlackCordgrips, '');
            self.setOptionValX(dat.id, s, '', 'Stainless Cordgrips', StainlessCordgrips, '');

            return self.reCalcOutput(dat.id, s, p, '', '', '', '');
        });
    }
    else if (_val.startsWith('DP')) {
        //#region DP Script

        let Base = 'DP100';
        let Probe = '';
        let Armor = '';
        let Metric = '';
        let Threading = '';
        let Style = '';
        let Code = '';
        let Unthreaded = '';
        let UnthreadedMetric = '';
        let CaseLength = '';
        let CaseLengthMetric = '';
        let TotalLength = '';
        let Connector = '';
        let Regulatory = '';

        let arval = val.split('-');

        Probe = arval[0].substring(0, 6);
        var lastChar = Probe[Probe.length - 1];

        try {
            // The codes for non metric probes
            Code = '<' + arval[0].charAt(5) + '>' + arval[0].substring(6, 8);

            Metric = 'Y';
            let nonmetrics = ['<9>01', '<9>02', '<9>06', '<9>11', '<1>01', '<1>02',
                '<1>05', '<7>01', '<7>02', '<7>05', '<8>01', '<8>02'];
            if (nonmetrics.includes(Code)) Metric = 'N';

            Armor = '0';
            if (Code.endsWith('02') || Code.endsWith('04')) Armor = '1';

            //Threading = '0';
            //if (['<9>01', '<9>02', '<9>11'].includes(Code)) Threading = '0';
            //if (['<9>03', '<9>04', '<9>12'].includes(Code)) Threading = '1';
            //if (['<7>05', '<1>05', '<1>02', '<1>01', '<9>06', '<1>03'].includes(Code)) Threading = '2';
            //if (['<1>03', '<9>07', '<1>04', '<1>06', '<7>06'].includes(Code)) Threading = '3';
            //if (['<7>01', '<7>02'].includes(Code)) Threading = '4';
            //if (['<7>03', '<7>04'].includes(Code)) Threading = '5';
            //if (['<8>01', '<8>02'].includes(Code)) Threading = '6';
            //if (['<8>03', '<8>04'].includes(Code)) Threading = '7';

            if (Metric == 'N') {
                Unthreaded = arval[1];
                CaseLength = arval[2];
            }
            else {
                UnthreadedMetric = arval[1];
                CaseLengthMetric = arval[2];
            }

            let reversemounts = [
                '<9>06', '<9>11', '<1>05', '<7>05',
                '<9>07',  '<9>12',  '<1>06',  '<7>06'];
            if (reversemounts.includes(Code)) {
                if (Metric == 'N' && CaseLength == '12') {
                    CaseLength = "_" + CaseLength;
                }
            }

            Style = '0';
            if (['<1>05', '<1>06', '<7>03', '<1>03', '<9>01', '<9>02', '<9>03', '<9>04', '<1>01',
                '<1>02', '<1>04', '<7>01', '<7>02', '<7>04', '<8>01', '<8>02', '<8>03', '<8>04'].includes(Code)) Style = '1';

            TotalLength = arval[3];
            Connector = arval[4];
            Regulatory = arval[5];
        }
        catch { }

        let z = 0;
        self.setState((s, p) => {

            self.setOptionValX(dat.id, s, '', 'Base', Base, '');
            self.setOptionValX(dat.id, s, '', 'Probe', Probe, '');
            self.setOptionValX(dat.id, s, '', 'Armor', Armor, '');
            self.setOptionValX(dat.id, s, '', 'Metric', Metric, '');
            //self.setOptionValX(dat.id, s, '', 'Threading', Threading, '');
            self.setOptionValX(dat.id, s, '', 'Style', Style, '');
            self.setOptionValX(dat.id, s, '', 'Code', Code, '');
            self.setOptionValX(dat.id, s, '', 'Unthreaded', Unthreaded, '');
            self.setOptionValX(dat.id, s, '', 'Unthreaded Metric', UnthreadedMetric, '');
            self.setOptionValX(dat.id, s, '', 'Case Length', CaseLength, '');
            self.setOptionValX(dat.id, s, '', 'Case Length Metric', CaseLengthMetric, '');
            self.setOptionValX(dat.id, s, '', 'Total Length', TotalLength, '');
            self.setOptionValX(dat.id, s, '', 'Connector', Connector, '');
            self.setOptionValX(dat.id, s, '', 'Regulatory', Regulatory, '');

            return self.reCalcOutput(dat.id, s, p, '', '', '', '');
        });
        //#endregion
    }

    else if (_val.startsWith('DR')) {
        //#region DR Script
        let driver = '';
        let system_len = '';
        let mounting_type = '';
        let keyways = '';
        let full_scale_rpm = '';
        let reg_approval = '';

        let arval = val.split('-');

        driver = arval[0];
        try {
            system_len = arval[1][0];
            mounting_type = arval[1][1];

            keyways = parseInt(arval[2]).toString();
            full_scale_rpm = parseInt(arval[3]).toString();

            reg_approval = arval[4];
        }
        catch { }

        let z = 0;

        self.setState((s, p) => {
            self.setOptionValX(dat.id, s, '', 'Driver', driver, '');
            self.setOptionValX(dat.id, s, '', 'System Length', system_len, '');
            self.setOptionValX(dat.id, s, '', 'Mounting Type', mounting_type, '');
            self.setOptionValX(dat.id, s, '', '# of Keyways', keyways, '');
            self.setOptionValX(dat.id, s, '', 'Full Scale RPM', full_scale_rpm, '');
            self.setOptionValX(dat.id, s, '', 'Regulatory Approval', reg_approval, '');

            return self.reCalcOutput(dat.id, s, p, '', '', '', '');
        });
        //#endregion
    }
    else if (_val.startsWith('CB') && arvals.length == 1 && arvals2.length == 2) {
        //#region USB Script
        let OTH = val;

        self.setState((s, p) => {

            self.setOptionValX(dat.id, s, '', 'Part Number', OTH, '');

            return self.reCalcOutput(dat.id, s, p, '', '', '', '');
        });
        //#endregion
    }
    else if (_val.startsWith('DM937') || _val.startsWith('DM938') ||
        _val.startsWith('USB') || _val.startsWith('MH') || _val.startsWith('CP') ||
        _val.startsWith('CM') || _val.startsWith('CK') || _val.startsWith('CA') ||
        _val.startsWith('CTC') || _val.startsWith('CB9') || _val.startsWith('CBR') ||
        _val.startsWith('JCI') || (_val.startsWith('TM') && !_val.startsWith('TMC')) ||
        _val.startsWith('VE101-1A') || _val.startsWith('VE102-1A') || _val.startsWith('PL-PRICING') ||
        _val.startsWith('ACCESS')) {
        //#region USB Script
        let OTH = val;

        self.setState((s, p) => {

            self.setOptionValX(dat.id, s, '', 'Part Number', OTH, '');

            return self.reCalcOutput(dat.id, s, p, '', '', '', '');
        });
        //#endregion
    }
    else if (_val.startsWith('CB') || _val.startsWith('TMC')) {
        //#region CB Script
        let units = '';
        let cable = '';
        let armor = '';
        let length = '';
        let coiled = '';
        let con1 = '';
        let con2 = '';
        let sf = '?'
        let color = '?';
        let portable = '?';
        let hz = '_';

        let arval = val.split('-');

        cable = arval[0];
        try {
            con1 = arval[1];
            con2 = arval[3];

            hz = arval[arval.length - 1];
            if (hz != 'HZ') hz = '_';
            else arval.pop();

            if (cable == 'CB104' || cable == 'CB108' || cable == 'CB117') {
                coiled = cable + ' (' + arval[2] + ')'
                armor = '10';
                length = '10';
            }
            else {
                arval[2] = arval[2].replaceAll(',', '.');

                let arlens = arval[2].split('/');
                units = arval[2].includes('M') ? 'M' : '_';
                armor = parseFloat(arlens[0]).toString();
                length = parseFloat(arlens[0]).toString();
                if (arval[2].includes('/')) length = parseFloat(arlens[1]).toString();
            }

            if (arval[4].startsWith("SF")) {
                sf = arval[4];
                color = arval[5];
            }
            else {
                color = arval[4];
            }
        }
        catch (e) {
            //debugger;
        }

        let arr = [
            'CB117', 'CB104', 'TMC03', 'TMC01', 'CB108', 'TMC02', 'CB103'];

        //if (arr.includes(cable)) {
        //    portable = "1";
        //} else
        //{
        //    portable = "0";
        //}

        if (!color) { color = "?"; }
        if (!sf) { color = "?"; }


        self.setState((s, p) => {
            self.setOptionValX(dat.id, s, '', 'Units', units, '');

            self.setOptionValX(dat.id, s, '', 'Base', "CABLE", '');
            self.setOptionValX(dat.id, s, '', 'Portable', portable, '');
            self.setOptionValX(dat.id, s, '', 'Cable', cable, '');
            self.setOptionValX(dat.id, s, '', 'Armor Length', armor, '');
            self.setOptionValX(dat.id, s, '', 'Length', length, '');
            self.setOptionValX(dat.id, s, '', 'Coiled Length', coiled, '');
            self.setOptionValX(dat.id, s, '', 'Connector 1', con1, '');
            self.setOptionValX(dat.id, s, '', 'Connector 2', con2, '');
            self.setOptionValX(dat.id, s, '', 'Safety Feature', sf, '');
            self.setOptionValX(dat.id, s, '', 'Color Coding', color, '');
            self.setOptionValX(dat.id, s, '', 'Hazardous', hz, '');

            return self.reCalcOutput(dat.id, s, p, '', '', '', '');
        });
        //#endregion
    }

    else if (_val.startsWith('SCC') || _val.startsWith('IS')) {
        //#region SCC Script
        let OTH = val;

        self.setState((s, p) => {

            self.setOptionValX(dat.id, s, '', 'Part Number', OTH, '');

            return self.reCalcOutput(dat.id, s, p, '', '', '', '');
        });
        //#endregion
    }

    else if (_val.startsWith('SC3')) {
        //#region SC3 Script
        let SC3 = 'SC3';
        let Channels = '';
        let InputUnits = '';
        let InputSource = '';
        let Power = '';
        let FullScaleRange1 = '';
        let OutputUnit1 = '';
        let Measurement1 = '';
        let HPF1 = '';
        let LPF1 = '';
        let Output1 = '';
        let FullScaleRange2 = '';
        let OutputUnit2 = '';
        let Measurement2 = '';
        let HPF2 = '';
        let LPF2 = '';
        let Output2 = '';
        let Smoothing1 = '';
        let Smoothing2 = '';

        val = val.substring(3);
        let arval = val.split('-');

        try {



            Channels = arval[0];
            InputUnits = arval[1][0];
            InputSource = arval[1][1];
            if (InputUnits == 'V') InputSource = '_' + InputSource;
            if (InputUnits == 'D') InputSource = '#' + InputSource;

            FullScaleRange1 = arval[2][0];
            OutputUnit1 = arval[2][1];
            Measurement1 = arval[2][2];
            HPF1 = arval[2][3];
            LPF1 = arval[2][4];
            Output1 = arval[2][5];

            if (Channels.startsWith("2")) {
                FullScaleRange2 = arval[3][0];
                OutputUnit2 = arval[3][1];
                Measurement2 = arval[3][2];
                HPF2 = arval[3][3];
                LPF2 = arval[3][4];
                Output2 = arval[3][5];

                Power = arval[4];
                Smoothing1 = arval[5][0];
                Smoothing2 = arval[5][1];
            }
            else {
                Power = arval[3];
                Smoothing1 = arval[4];
            }



        }
        catch { }

        self.setState((s, p) => {

            self.setOptionValX(dat.id, s, '', 'SC3', SC3, '');
            self.setOptionValX(dat.id, s, '', 'Channels', Channels, '');
            self.setOptionValX(dat.id, s, '', 'Input Units', InputUnits, '');
            self.setOptionValX(dat.id, s, '', 'Input Source', InputSource, '');
            self.setOptionValX(dat.id, s, '', 'Power', Power, '');
            self.setOptionValX(dat.id, s, '', 'Full Scale Range 1', FullScaleRange1, '');
            self.setOptionValX(dat.id, s, '', 'Output Unit 1', OutputUnit1, '');
            self.setOptionValX(dat.id, s, '', 'Measurement 1', Measurement1, '');
            self.setOptionValX(dat.id, s, '', 'HPF 1', HPF1, '');
            self.setOptionValX(dat.id, s, '', 'LPF 1', LPF1, '');
            self.setOptionValX(dat.id, s, '', 'Output 1', Output1, '');
            self.setOptionValX(dat.id, s, '', 'Full Scale Range 2', FullScaleRange2, '');
            self.setOptionValX(dat.id, s, '', 'Output Unit 2', OutputUnit2, '');
            self.setOptionValX(dat.id, s, '', 'Measurement 2', Measurement2, '');
            self.setOptionValX(dat.id, s, '', 'HPF 2', HPF2, '');
            self.setOptionValX(dat.id, s, '', 'LPF 2', LPF2, '');
            self.setOptionValX(dat.id, s, '', 'Output 2', Output2, '');

            self.setOptionValX(dat.id, s, '', 'Smoothing', Smoothing1, '');
            self.setOptionValX(dat.id, s, '', 'Smoothing 2', Smoothing2, '');

            return self.reCalcOutput(dat.id, s, p, '', '', '', '');
        });
        //#endregion
    }

    else if (_val.startsWith('SSB-MOD') || _val.startsWith('DSB-MOD') || _val.startsWith('TSB-MOD') || _val.startsWith('MMX-MOD')) {
        var BoxMod = '';
        var ModuleType = '';
        var Channels = '';
        var ConnectorCompatibility = '';
        var Output = '';

        try {
            let arval = val.split('-');
            ModuleType = arval[0] + "-" + arval[1].substring(0, 3);
            if (arval[0] == "SSB" || arval[0] == "DSB" || arval[0] == "MMX") {
                Channels = arval[1].match(/\d+/g);
                if (arval[2] != null && arval[2] != '') {
                    Output = arval[2];
                }
                else {
                    Output = '_';
                }

            }
            else if (arval[0] == "TSB") {
                Channels = arval[1].match(/\d+/g);
                if (Channels == 12) { Channels = "_12";}

                ConnectorCompatibility = arval[2];

                if (arval[3] != null && arval[3] != '') {
                    Output = arval[3];
                }
                else {
                    Output = '_';
                }

            }
            self.setState((s, p) => {

                //self.setOptionValX(dat.id, s, '', 'Box Mod', BoxMod, '');
                self.setOptionValX(dat.id, s, '', 'Module Type', ModuleType, '');
                self.setOptionValX(dat.id, s, '', 'Channels', Channels, '');
                self.setOptionValX(dat.id, s, '', 'Connector Compatibility', ConnectorCompatibility, '');
                self.setOptionValX(dat.id, s, '', 'Output', Output, '');

                return self.reCalcOutput(dat.id, s, p, '', '', '', '');
            });
        }
        catch { }


    }

    else if (_val.startsWith('SCE')) {
        //#region SCE Script

        let SCE = 'SCE';
        let EnclosureMaterial = '';
        let Ethernet420 = '';
        let InputSignal = '';
        let EnclosureSize = '';
        let NumberofInstalledSC300 = '';
        let EnclosureEntry = '';
        let Output = '';
        let SizeAndMaterial = '';

        val = val.substring(3);
        let arval = val.split('-');

        try {
            SizeAndMaterial = arval[0][0];
            Ethernet420 = arval[0][1];
            InputSignal = arval[0][2];

            //EnclosureSize = arval[1][0];
            NumberofInstalledSC300 = arval[1]; //[1];

            EnclosureEntry = arval[2][0];
            Output = arval[2][1];

            EnclosureMaterial = SizeAndMaterial == "1" || SizeAndMaterial == "3" ? "1" : "2";

            // switch to stainless options
            if ((EnclosureEntry == "B" || EnclosureEntry == "C") && EnclosureMaterial == "2") EnclosureEntry += "_";
            if ((Output == "B") && EnclosureMaterial == "2") Output += "_";
        }
        catch { }

        self.setState((s, p) => {

            self.setOptionValX(dat.id, s, '', 'SCE', SCE, '');
            self.setOptionValX(dat.id, s, '', 'Enclosure Material', EnclosureMaterial, '');
            self.setOptionValX(dat.id, s, '', 'Input Signal', InputSignal, '');
            self.setOptionValX(dat.id, s, '', 'Ethernet420', Ethernet420, '');
            self.setOptionValX(dat.id, s, '', 'Enclosure Size', EnclosureSize, '');
            self.setOptionValX(dat.id, s, '', 'Number of Installed SC300', NumberofInstalledSC300, '');
            self.setOptionValX(dat.id, s, '', 'Enclosure Entry', EnclosureEntry, '');
            self.setOptionValX(dat.id, s, '', 'Output', Output, '');
            self.setOptionValX(dat.id, s, '', 'Size and Material', SizeAndMaterial, '');

            return self.reCalcOutput(dat.id, s, p, '', '', '', '');
        });
        //#endregion
    }

    else if (_val.startsWith('LP') || _val.startsWith('HVLP')) {
        //#region Sensor Script        
        let StudType = '';
        let Sensor = '';

        let MeasurementRange = '';
        let RangeType = '';
        let FrequencyRange = '';
        let MeasurementRangeY = '';
        let RangeTypeY = '';
        let FrequencyRangeY = '';
        let MeasurementRangeZ = '';
        let RangeTypeZ = '';
        let FrequencyRangeZ = '';

        let ArmorLength = '';
        let Length = '';
        let Units = '';
        let Connector = '';
        let SafetyFeature = '';
        let ColorCoding = '';
        let Cable = '';
        let Tolerance = '';
        let C1 = '';
        let LPX = '';

        let TriaxConfigY = '';
        let TriaxConfigZ = '';

        let midSection = '-$$$-';

        // If triax, parse our the y and z axis configurations
        if (_val.startsWith('LPT')) {            
            let arr = val.split('-');
            TriaxConfigY = arr[2];
            TriaxConfigZ = arr[3];
            midSection += '$$$-$$$-';

            MeasurementRangeY = TriaxConfigY[0];
            RangeTypeY = TriaxConfigY[1];
            FrequencyRangeY = TriaxConfigY[2];
            MeasurementRangeZ = TriaxConfigZ[0];
            RangeTypeZ = TriaxConfigZ[1];
            FrequencyRangeZ = TriaxConfigZ[2];
            
            // Remove the triax configs to process the part number using the standard format
            val = val.replace("-" + TriaxConfigY + "-" + TriaxConfigZ, '');
        }

        let arval = val.split('/');
        let arval2 = val.split('-');

        if (arval2[2].startsWith('T'))
        {
            val = "";
            Tolerance = arval2[2];
            for (let x = 0; x < arval2.length; x++)
            {
                if (x != 2) {
                    val += arval2[x] + "-"
                }
            }
            val = val.substr(0, val.length - 1);
        }

        arval = val.split('/');
        arval2 = val.split('-');

        try {
            StudType = "_";
            if (arval[0] == "M" || arval[0] == "P25" || arval[0] == "M8") {
                StudType = arval[0];
                val = val.substring(val.indexOf('/') + 1);
                arval = val.split('/');
            }

            let LPParts = arval[0].split('-');
            LPX = LPParts[0];
            C1 = LPParts[2];
            Sensor = LPParts[0] + midSection + LPParts[2];

            if (LPParts[1].length == 4) {

                MeasurementRange = LPParts[1][0] + LPParts[1][1];
                RangeType = LPParts[1][2];
                FrequencyRange = LPParts[1][3];
            }
            else {
                MeasurementRange = LPParts[1][0];
                RangeType = LPParts[1][1];
                FrequencyRange = LPParts[1][2];
            }

            let arval_0 = arval[0].replace('HV', '');

            // Adjust the measurement range for G based LPs
            if (arval_0.startsWith("LP3") || arval_0.startsWith("LPT3") ||
                arval_0.startsWith("LP9") || arval_0.startsWith("LP404") || 
                arval_0.startsWith("LP6"))
            {
                MeasurementRange = "_" + MeasurementRange;
            }

            // Adjust the frequency range for the LP5s ad LP6s
            if (arval_0.startsWith("LP5") || arval_0.startsWith("LP6"))
            {
                FrequencyRange = FrequencyRange + "_";
            }
            else {

            }



            let gtval = 2;
            if (arval[arval.length - 1].startsWith("T0")) {
                gtval++;
            }


            let endchunk = [];
            if (arval.length > gtval) {
                ArmorLength = arval[1];
                endchunk = arval[2].split('-');
            }
            else {
                endchunk = arval[1].split('-');
            }
            Length = endchunk[0];

            Units = "_";
            if (Length.includes('M')) {
                Length = Length.replaceAll('M', '');
                ArmorLength = ArmorLength.replaceAll('M', '');
                Units = "M";
            }

            Length = Length.replaceAll(',', '.');
            ArmorLength = ArmorLength.replaceAll(',', '.');

            Length = parseFloat(Length).toString();
            ArmorLength = parseFloat(ArmorLength).toString();

            Connector = endchunk[1];

            if (gtval > 2) {
                //Tolerance = arval[arval.length - 1].split('-')[0];
            }

            let ending = arval2[arval2.length - 1]
            if (ending != Connector) ColorCoding = ending;
        } catch { }

        if (SafetyFeature == '' || SafetyFeature == null) {
            SafetyFeature = '?';
        }
        if (ColorCoding == '' || ColorCoding == null) {
            ColorCoding = '?';
        }
        if (Tolerance == '' || Tolerance == null) {
           
            if (Sensor.startsWith("LP5") || Sensor.startsWith("LP6"))
            {
                // This enforces the need for tolerance on LP5 and LP6 sensors
                Tolerance = '';
            }
            else
            {
                // This makes the tolerance optional
                Tolerance = '?';
            }
        }

        self.setState((s, p) => {

            self.setOptionValX(dat.id, s, '', 'Stud Type', StudType, '');
            self.setOptionValX(dat.id, s, '', 'LP', Sensor, '');

            self.setOptionValX(dat.id, s, '', 'Measurement Range', MeasurementRange, '');
            self.setOptionValX(dat.id, s, '', 'Range Type', RangeType, '');
            self.setOptionValX(dat.id, s, '', 'Frequency Range', FrequencyRange, '');

            self.setOptionValX(dat.id, s, '', 'Measurement Range Y Axis', MeasurementRangeY, '');
            self.setOptionValX(dat.id, s, '', 'Range Type Y Axis', RangeTypeY, '');
            self.setOptionValX(dat.id, s, '', 'Frequency Range Y Axis', FrequencyRangeY, '');
            self.setOptionValX(dat.id, s, '', 'Measurement Range Z Axis', MeasurementRangeZ, '');
            self.setOptionValX(dat.id, s, '', 'Range Type Z Axis', RangeTypeZ, '');
            self.setOptionValX(dat.id, s, '', 'Frequency Range Z Axis', FrequencyRangeZ, '');

            self.setOptionValX(dat.id, s, '', 'Armor Length', ArmorLength, '');
            self.setOptionValX(dat.id, s, '', 'Length', Length, '');
            self.setOptionValX(dat.id, s, '', 'Units', Units, '');
            self.setOptionValX(dat.id, s, '', 'Connector', Connector, '');
            self.setOptionValX(dat.id, s, '', 'Safety Feature', SafetyFeature, '');
            self.setOptionValX(dat.id, s, '', 'Color Coding', ColorCoding, '');
            self.setOptionValX(dat.id, s, '', 'Cable', Cable, '');
            self.setOptionValX(dat.id, s, '', 'Tolerance', Tolerance, '');
            self.setOptionValX(dat.id, s, '', 'C1', C1, '');
            self.setOptionValX(dat.id, s, '', 'LPX', LPX, '');

            return self.reCalcOutput(dat.id, s, p, '', '', '', '');
        });
        //#endregion
    }

    else if (_val.startsWith('TCT')) {
        let Box = '';
        let Sensor = '';
        let BoxSize = '';
        let BoxMaterial = '';
        let SizeandMaterial = '';
        let ContinuousOutput = '';
        let EnclosureType = '';
        let GroundLugs = '_';
        let Channels = '';
        let ConnectorCompatibility = '';
        let Input = '';
        let Output = '';

        let arval = val.split('-');
        EnclosureType = arval[0];

        Channels = arval[1][0];
        if (Channels == "1") { Channels = "1_" }

        Input = arval[1].match(/[a-zA-Z]+/g);

        // is it safe to say that Input[0] should always end with a _ for TCT?
        if (Input[0] == "A") { Input[0] = "A_" }
        if (Input[0] == "B") { Input[0] = "B_" }
        if (Input[0] == "C") { Input[0] = "C_" }
        if (Input[0] == "E") { Input[0] = "E_" }
        if (Input[0] == "R") { Input[0] = "R_" }

        EnclosureType = arval[0];
        if (EnclosureType.endsWith("G")) {
            GroundLugs = 'G';
            EnclosureType = EnclosureType.substr(0, EnclosureType.length - 1);
        }

        self.setState((s, p) => {
            self.setOptionValX(dat.id, s, '', 'Enclosure Type', EnclosureType, '');
            self.setOptionValX(dat.id, s, '', 'Ground Lugs', GroundLugs, '');
            self.setOptionValX(dat.id, s, '', 'Channels', Channels, '');
            self.setOptionValX(dat.id, s, '', 'Input', Input, '');
            return self.reCalcOutput(dat.id, s, p, '', '', '', '');
        });
    }

    else if (
        _val.startsWith('AC') || _val.startsWith('TA') || _val.startsWith('TC') ||
        _val.startsWith('WT') || _val.startsWith('VE') || _val.startsWith('TR') ||
        _val.startsWith('VT') || _val.startsWith('TR') || _val.startsWith('MA') ||
        _val.startsWith('UEB') || _val.startsWith('UEA') || _val.startsWith('MEB') ||
        _val.startsWith('MCB') || _val.startsWith('BSFA') || _val.startsWith('TK') ||
        _val.startsWith('TX') ||
        _val.startsWith('TCEB') ||
        _val.startsWith('TRCA') || _val.startsWith('TREA') || _val.startsWith('TSFA') ||
        _val.startsWith('TEB') || _val.startsWith('TCB') || _val.startsWith('TEA') ||
        _val.startsWith('TCA')) {
        //#region Sensor Script

        let StudType = '';
        let Sensor = '';
        let ArmorLength = '';
        let Length = '';
        let Units = '';
        let Connector = '';
        let SafetyFeature = '';
        let ColorCoding = '';
        let Cable = '';
        let Tolerance = '';
        let TMPStudType = '';
        let TMPStudType2 = '';

        //AC102-2C/010-L/T05-AA
        //AC102-3C/010/010-L/T05-AA
        //MEB210/010-L/T05-AA

        let arval = val.split('/');
        let arval2 = val.split('-');

        try {

            StudType = "_";
            if (arval[0] == "M" || arval[0] == "P25" || arval[0] == "M8") {
                StudType = arval[0];
                val = val.substring(val.indexOf('/') + 1);
                arval = val.split('/');
                arval2 = val.split('-');
            }

            Sensor = arval[0];

            //if (
            //    Sensor.startsWith("TRCA") ||
            //    Sensor.startsWith("TREA") ||
            //    Sensor.startsWith("TXFA") ||
            //    Sensor.startsWith("TXEA") ||
            //    Sensor.startsWith("TSFA") ||
            //    Sensor.startsWith("BSFA") ||
            //    Sensor.startsWith("TCEB") ||
            //    false)
            //{
            //    let newSensor = Sensor.substr(0, 5) + "3" + Sensor.substr(6);
            //    TMPStudType = Sensor.substr(5, 1);
            //    Sensor = newSensor;
            //}

            //if (
            //    Sensor.startsWith("UEA") ||
            //    Sensor.startsWith("UEB") ||
            //    false) {
            //    let newSensor = Sensor.substr(0, 4) + "3" + Sensor.substr(5);
            //    TMPStudType = Sensor.substr(4, 1);
            //    Sensor = newSensor;
            //}

            //if (
            //    Sensor.startsWith("MEB") ||
            //    Sensor.startsWith("MCB") ||
            //    Sensor.startsWith("TEB") ||
            //    Sensor.startsWith("TCB") ||
            //    Sensor.startsWith("TEA") ||
            //    Sensor.startsWith("TCA") ||
            //    false) {
            //    let newSensor = Sensor.substr(0, 4) + "1" + Sensor.substr(5);
            //    TMPStudType2 = Sensor.substr(4, 1);
            //    Sensor = newSensor;
            //}


            let gtval = 2;
            if (arval[arval.length - 1].startsWith("T0"))
            {
                gtval++;
            }


            let endchunk = [];
            if (arval.length > gtval) {
                ArmorLength = arval[1];
                endchunk = arval[2].split('-');
            }
            else {
                endchunk = arval[1].split('-');
            }
            Length = endchunk[0];

            Units = "_";
            if (Length.includes('M')) {
                Length = Length.replaceAll('M', '');
                ArmorLength = ArmorLength.replaceAll('M', '');
                Units = "M";
            }

            Length = Length.replaceAll(',', '.');
            ArmorLength = ArmorLength.replaceAll(',', '.');

            Length = parseFloat(Length).toString();
            ArmorLength = parseFloat(ArmorLength).toString();

            Connector = endchunk[1];

            if (gtval > 2)
            {
                Tolerance = arval[arval.length - 1].split('-')[0];
            }

            let ending = arval2[arval2.length - 1]
            if (ending != Connector) ColorCoding = ending;
        }
        catch { }

        if (SafetyFeature == '') {
            SafetyFeature = '?';
        }
            if (ColorCoding == '') {
            ColorCoding = '?';
        }
        if (Tolerance == '') {
            Tolerance = '?';
        }

        self.setState((s, p) => {

            self.setOptionValX(dat.id, s, '', 'Stud Type', StudType, '');
            self.setOptionValX(dat.id, s, '', 'Sensor', Sensor, '');
            self.setOptionValX(dat.id, s, '', 'Armor Length', ArmorLength, '');
            self.setOptionValX(dat.id, s, '', 'Length', Length, '');
            self.setOptionValX(dat.id, s, '', 'Units', Units, '');
            self.setOptionValX(dat.id, s, '', 'Connector', Connector, '');
            //self.setOptionValX(dat.id, s, '', 'Safety Feature', SafetyFeature, '');
            self.setOptionValX(dat.id, s, '', 'Color Coding', ColorCoding, '');
            self.setOptionValX(dat.id, s, '', 'Cable', Cable, '');
            self.setOptionValX(dat.id, s, '', 'Tolerance', Tolerance, '');
            self.setOptionValX(dat.id, s, '', 'TMP Stud Type', TMPStudType, '');
            self.setOptionValX(dat.id, s, '', 'TMP Stud Type 2', TMPStudType2, '');

            return self.reCalcOutput(dat.id, s, p, '', '', '', '');
        });
        //#endregion
    }

    else if (
        _val.startsWith('JB') || _val.startsWith('SB') ||
        _val.startsWith('SSB') || _val.startsWith('DSB') || _val.startsWith('TSB')) {


        if (_val.startsWith('JB') || _val.startsWith('SB')) {
            let Box = '';
            let Sensor = '';
            let BoxSize = '';
            let BoxMaterial = '';
            let SizeandMaterial = '';
            let ContinuousOutput = '';
            let EnclosureType = '';
            let Channels = '';
            let ConnectorCompatibility = '';
            let Input = '';
            let Output = '';

            let arval = val.split('-');
            EnclosureType = arval[0];
            Channels = arval[1].match(/\d+/g);
            Input = arval[1].match(/[a-zA-Z]+/g);

            //if ((EnclosureType == "SB142" && (Input == "E" || Input == "D")) ||
            //    (EnclosureType == "SB102" && (Input == "E" || Input == "D")) ||
            //    (EnclosureType == "SB202" && (Input == "E" || Input == "D")) ||
            //    (EnclosureType == "SB262" && (Input == "E" || Input == "D")) ||
            //    (EnclosureType == "SB282" && (Input == "E" || Input == "D"))
            //) {
            //    Input = Input + "_";
            //}

            self.setState((s, p) => {
                self.setOptionValX(dat.id, s, '', 'Enclosure Type', EnclosureType, '');
                self.setOptionValX(dat.id, s, '', 'Channels', Channels, '');
                self.setOptionValX(dat.id, s, '', 'Input', Input, '');
                return self.reCalcOutput(dat.id, s, p, '', '', '', '');
            });
        }
        else if (_val.startsWith('SSB')) {
            let Box = '';
            let Sensor = '';
            let BoxSize = '';
            let BoxMaterial = '';
            let SizeandMaterial = '';
            let ContinuousOutput = '';
            let EnclosureType = '';
            let Channels = '';
            let ConnectorCompatibility = '';
            let Input = '';
            let Output = '';



            let arval = val.split('-');
            EnclosureType = arval[0].substring(0, 7);

            // If Barrier Enclosure
            if (_val.startsWith('SSB9') && (val.split('-')[1].match(/[a-zA-Z]+/g) == 'B')) {
                var BarrierSystem = '';
                var NumberOfChannels = '';
                var EnclosureEntry = '';
                var EnclosureExit = '';

                BarrierSystem = arval[0];
                NumberOfChannels = arval[1].match(/\d+/g);
                EnclosureEntry = arval[2].charAt(0);
                EnclosureExit = arval[2].charAt(1);

                self.setState((s, p) => {
                    self.setOptionValX(dat.id, s, '', 'Barrier System', BarrierSystem, '');
                    self.setOptionValX(dat.id, s, '', 'Number Of Channels', NumberOfChannels, '');
                    self.setOptionValX(dat.id, s, '', 'Enclosure Entry', EnclosureEntry, '');
                    self.setOptionValX(dat.id, s, '', 'Enclosure Exit', EnclosureExit, '');

                    return self.reCalcOutput(dat.id, s, p, '', '', '', '');
                });

            }
            // if Box
            else if (_val.startsWith('SSB')) {

                Channels = arval[1].match(/\d+/g);
                Input = arval[1].match(/[a-zA-Z]+/g);
                // For SSB900 series
                if (EnclosureType.charAt(3) == 9) {
                    Input = arval[2].charAt(0);
                    Output = arval[2].charAt(1);
                    Channels = parseInt(arval[1]);
                }
                ContinuousOutput = arval[0].charAt(6);
                if (ContinuousOutput > 1 && _val.startsWith('SSB')) {
                    EnclosureType = EnclosureType + "_";
                }
                if (EnclosureType.lastChar == '0') {

                }


                self.setState((s, p) => {
                    self.setOptionValX(dat.id, s, '', 'Enclosure Type', EnclosureType, '');
                    self.setOptionValX(dat.id, s, '', 'Channels', Channels, '');
                    self.setOptionValX(dat.id, s, '', 'Input', Input, '');
                    //self.setOptionValX(dat.id, s, '', 'Continuous Output', ContinuousOutput, '');
                    self.setOptionValX(dat.id, s, '', 'Output', Output, '');
                    return self.reCalcOutput(dat.id, s, p, '', '', '', '');
                });
            }




        }
        else if (_val.startsWith('DSB')) {
            let Box = '';
            let Sensor = '';
            let BoxSize = '';
            let BoxMaterial = '';
            let SizeandMaterial = '';
            let ContinuousOutput = '';
            let EnclosureType = '';
            let Channels = '';
            let ConnectorCompatibility = '';
            let Input = '';
            let Output = '';

            let arval = val.split('-');
            EnclosureType = arval[0].substring(0, 7);
            Channels = arval[1].match(/\d+/g);
            Input = arval[1].match(/[a-zA-Z]+/g);
            ContinuousOutput = arval[0].charAt(6);

            if (EnclosureType.lastChar != '0') {
                ContinuousOutput = arval[0].charAt(6);
                //EnclosureType = EnclosureType + "_";
            }

            //if (Channels == 8 || Channels == 16 || Channels == 24 || Channels == 32) {
            if (ContinuousOutput > 1) {
                EnclosureType = EnclosureType + "_";
            }
            self.setState((s, p) => {
                self.setOptionValX(dat.id, s, '', 'Enclosure Type', EnclosureType, '');
                self.setOptionValX(dat.id, s, '', 'Channels', Channels, '');
                self.setOptionValX(dat.id, s, '', 'Input', Input, '');
                //self.setOptionValX(dat.id, s, '', 'Continuous Output', ContinuousOutput, '');
                self.setOptionValX(dat.id, s, '', 'Output', Output, '');
                return self.reCalcOutput(dat.id, s, p, '', '', '', '');
            });
        }
        else if (_val.startsWith('TSB')) {
            let Box = '';
            let Sensor = '';
            let BoxSize = '';
            let BoxMaterial = '';
            let SizeandMaterial = '';
            let ContinuousOutput = '';
            let EnclosureType = '';
            let Channels = '';
            let ConnectorCompatibility = '';
            let Input = '';
            let Output = '';

            let arval = val.split('-');
            EnclosureType = arval[0].substring(0, 7);
            //ContinuousOutput = arval[0].charAt(6);
            if (ContinuousOutput > 1) {
                EnclosureType = EnclosureType + "_";
            }
            Channels = arval[1].match(/\d+/g);
            Input = arval[1].match(/[a-zA-Z]+/g);
            ConnectorCompatibility = arval[2];
            Input = arval[3].charAt(0);
            Output = arval[3].charAt(1);
            self.setState((s, p) => {
                self.setOptionValX(dat.id, s, '', 'Enclosure Type', EnclosureType, '');
                self.setOptionValX(dat.id, s, '', 'Channels', Channels, '');
                self.setOptionValX(dat.id, s, '', 'Input', Input, '');
                //self.setOptionValX(dat.id, s, '', 'Continuous Output', ContinuousOutput, '');
                self.setOptionValX(dat.id, s, '', 'Output', Output, '');
                self.setOptionValX(dat.id, s, '', 'Connector Compatibility', ConnectorCompatibility, '');
                return self.reCalcOutput(dat.id, s, p, '', '', '', '');
            });
        }

    }

    else if (_val.startsWith('CT')) {
        let Box = '';
        let Sensor = '';
        let BoxSize = '';
        let BoxMaterial = '';
        let SizeandMaterial = '';
        let ContinuousOutput = '';
        let EnclosureType = '';
        let GroundLugs = '_';
        let Channels = '';
        let ConnectorCompatibility = '';
        let Input = '';
        let Output = '';

        let arval = val.split('-');
        
        EnclosureType = arval[0];
        if (EnclosureType.endsWith("G"))
        {
            GroundLugs = 'G';
            EnclosureType = EnclosureType.substr(0, EnclosureType.length - 1);
        }

        Channels = arval[1].match(/\d+/g);
        Input = arval[1].match(/[a-zA-Z]+/g);

        // is it safe to say that Input[0] should always end with a _ for TCT?
        if (Input[0] == "A") { Input[0] = "A_" }
        if (Input[0] == "B") { Input[0] = "B_" }
        if (Input[0] == "C") { Input[0] = "C_" }

        self.setState((s, p) => {
            self.setOptionValX(dat.id, s, '', 'Enclosure Type', EnclosureType, '');
            self.setOptionValX(dat.id, s, '', 'Ground Lugs', GroundLugs, '');
            self.setOptionValX(dat.id, s, '', 'Channels', Channels, '');
            self.setOptionValX(dat.id, s, '', 'Input', Input[0], '');
            return self.reCalcOutput(dat.id, s, p, '', '', '', '');
        });
    }

    else if (_val.startsWith('CR') || _val.startsWith('CRHT') || _val.startsWith('MMX') || _val.startsWith('MX')) {
        let Box = '';
        let Sensor = '';
        let BoxSize = '';
        let BoxMaterial = '';
        let SizeandMaterial = '';
        let ContinuousOutput = '';
        let EnclosureType = '';
        let Channels = '';
        let ConnectorCompatibility = '';
        let Input = '';
        let Output = '';

        let arval = val.split('-');
        EnclosureType = arval[0];

        Channels = arval[1].match(/\d+/g);
        Input = arval[1].match(/[a-zA-Z]+/g);
        // These part configurations require a _ after certain input types. ("D" seems to be different than "D_")
        if ((EnclosureType == "MX262" && Input == "D") || (EnclosureType == "MX502" && Input == "E") || (EnclosureType == "MX502" && Input == "D") ||
            (EnclosureType == "MX102" && Input == "D") || (EnclosureType == "MX102" && Input == "E") || (EnclosureType == "MX202" && Input == "E") ||
            (EnclosureType == "MX202" && Input == "D") || (EnclosureType == "MX504" && Input == "E") || (EnclosureType == "MX504" && Input == "D") ||
            (EnclosureType == "MX505" && Input == "E") || (EnclosureType == "MX505" && Input == "D") || (EnclosureType == "MX542" && Input == "D") ||
            (EnclosureType == "MX333" && Input == "D") || (EnclosureType == "MX433" && Input == "D") || (EnclosureType == "MX503" && Input == "D") ||
            (EnclosureType == "MX503" && Input == "E") || (EnclosureType == "MMX6000" && Input == "D") || (EnclosureType == "MMX6000" && Input == "E"))
        {
            Input = Input + "_";
        }

        // To denote triaxial input
        if (_val.startsWith('CRHT')) {
            Input = Input + "_";
        }

        // To denote triaxial input
        if ((EnclosureType == "MX333") || (EnclosureType == "MX433") ||
            (EnclosureType == "MX503") || (EnclosureType == "MX504") || (EnclosureType == "MX505") ||
            (EnclosureType == "MX703") || (EnclosureType == "MX704") || (EnclosureType == "MX705") ||
            (EnclosureType == "MX742")) {
            Input = Input + "_";
            Channels = Channels + "_";
        }

        // Different input strips - we could not use universal (spring cage)
        if ((EnclosureType == "MX502") || (EnclosureType == "MX542") || (EnclosureType == "MX702")) {
            Input = Input + "_";
        }

        // Undid this on 9/27/2023
        // Different input strips - we could not use universal (spring cage)
        //if ((EnclosureType == "MX702")) {
        //    // Per Lotties requirement on 8/25/2023 MX702 needs C,S,N only compatible with 
        //    // 1 or 2 Channels, the only way to solve this was to create new restrictive C,S,N
        //    if ((Input + '' == 'C') || (Input + '' == 'S') || (Input + '' == 'N')) {
        //        Input = Input + "#";
        //    } else
        //    {
        //        Input = Input + "_";
        //    }
        //}

        self.setState((s, p) => {
            self.setOptionValX(dat.id, s, '', 'Enclosure Type', EnclosureType, '');
            self.setOptionValX(dat.id, s, '', 'Channels', Channels, '');
            self.setOptionValX(dat.id, s, '', 'Input', Input, '');
            return self.reCalcOutput(dat.id, s, p, '', '', '', '');
        });
    }


    else if (_val.startsWith('PXE')) {
        let Box = '';
        let Sensor = '';
        let BoxSize = '';
        let BoxMaterial = '';
        let SizeandMaterial = '';
        let ContinuousOutput = '';
        let EnclosureType = '';
        let Channels = '';
        let ConnectorCompatibility = '';
        let Input = '';
        let Output = '';
        let arval = val.split('-');

        EnclosureType = arval[0];
        if (EnclosureType.length > 6) {
            if (EnclosureType.endsWith("P")) {
                Option = "P";
                EnclosureType = EnclosureType.substring(0, EnclosureType.length - 1);
            }
            else if (EnclosureType.endsWith("T")) {
                Option = "T";
                EnclosureType = EnclosureType.substring(0, EnclosureType.length - 1);
            }

        }
        else {
            Option = "_";
        }
        Channels = arval[1];
        Input = arval[2].charAt(0) + "_";
        Output = arval[2].charAt(1);

        self.setState((s, p) => {
            self.setOptionValX(dat.id, s, '', 'Enclosure Type', EnclosureType, '');
            self.setOptionValX(dat.id, s, '', 'Channels', Channels, '');
            self.setOptionValX(dat.id, s, '', 'Input', Input, '');
            self.setOptionValX(dat.id, s, '', 'Continuous Output', ContinuousOutput, '');
            self.setOptionValX(dat.id, s, '', 'Output', Output, '');
            self.setOptionValX(dat.id, s, '', 'Connector Compatibility', ConnectorCompatibility, '');
            self.setOptionValX(dat.id, s, '', 'Option', Option, '');
            return self.reCalcOutput(dat.id, s, p, '', '', '', '');
        });
    }

    else if (_val.startsWith('DD') || _val.startsWith('DR') || _val.startsWith('dd')) {
        let Driver = '';
        let FullScale = '';
        let SystemLength = '';
        let MountingType = '';
        let NoOfKeyways = '';
        let FullScaleRPM = '';
        let RegulatoryApproval = '';

        let arval = val.split('-');
        Driver = arval[0];
        if (arval.length == 7) {
            Driver = arval[0] + "-" + arval[1] + "-" + arval[2] + "-" + arval[3] + "-" + arval[4];
            SystemLength = arval[5].charAt(0) + arval[5].charAt(1);
            MountingType = arval[5].charAt(2);
            RegulatoryApproval = arval[6];
        }
        else if (arval.length == 5 && arval[3].length == 3) {
            Driver = arval[0] + "-" + arval[1] + "-" + arval[2];
            SystemLength = arval[3].charAt(0) + arval[3].charAt(1);
            MountingType = arval[3].charAt(2);
            RegulatoryApproval = arval[4];
        }
        else if (arval.length == 5 && arval[0].charAt(7) == "1") {
            if (arval[1] == "06" || arval[1] == "12") {
                FullScale = "_" + arval[1];
            }
            else {
                FullScale = arval[1];
            }

            SystemLength = arval[2];
            MountingType = arval[3];//.charAt(1);
            RegulatoryApproval = arval[4];
        }
        else if (arval.length == 5) {
            if (arval[0].substring(5, 8) == "890" && arval[1] == "05") {

                FullScale = "#" + arval[1];
            }
            else if (arval[0].substring(5, 8) == "790" && arval[1] == "06") {
                FullScale = "#" + arval[1];
            }
            else {
                FullScale = arval[1];
            }

            //SystemLength = parseInt(arval[2].match(/\d+/g));
            SystemLength = arval[2].charAt(0) + arval[2].charAt(1);

            MountingType = arval[3];//.charAt(1);
            RegulatoryApproval = arval[4];
        }
        else if (arval.length == 3) {
            //FullScale = arval[1];
            SystemLength = arval[1].charAt(0);
            MountingType = arval[1].charAt(1);
            RegulatoryApproval = arval[2];
        }


        //if (_val.startsWith('DD111') || _val.startsWith('DD100')) {
        //    FullScale = arval[1];
        //    SystemLength = arval[1].charAt(0);
        //    MountingType = arval[1].charAt(1);
        //    RegulatoryApproval = arval[2];
        //}
        //else if (_val.startsWith('DD')) {
        //    FullScale = arval[1];
        //    SystemLength = arval[2];
        //    MountingType = arval[3].charAt(1);
        //    RegulatoryApproval = arval[4];
        //}


        self.setState((s, p) => {
            self.setOptionValX(dat.id, s, '', 'Driver', Driver, '');
            self.setOptionValX(dat.id, s, '', 'Full Scale', FullScale, '');
            self.setOptionValX(dat.id, s, '', 'System Length', SystemLength, '');
            self.setOptionValX(dat.id, s, '', 'Mounting Type', MountingType, '');
            self.setOptionValX(dat.id, s, '', 'Regulatory Approval', RegulatoryApproval, '');
            return self.reCalcOutput(dat.id, s, p, '', '', '', '');
        });

    }
    else if (_val.startsWith('SCD')) {
        let Material = '';
        let SCD = '';
        let TypeofSC = '';
        let InputChannels = '';
        let EnclosureEntry = '';
        let EnclosureExit = '';
        let StackLight = '';

        let arval = val.split('-');
        try {
            SCD = arval[0];
            Material = arval[0].charAt(3);
            TypeofSC = arval[0].charAt(4);
            InputChannels = arval[0].charAt(5);

            EnclosureEntry = arval[1].charAt(0);
            EnclosureExit = arval[1].charAt(1);
            StackLight = arval[2] || '';

        }
        catch {

        }


        self.setState((s, p) => {
            self.setOptionValX(dat.id, s, '', 'Type of SC', TypeofSC, '');
            self.setOptionValX(dat.id, s, '', 'Material', Material, '');
            self.setOptionValX(dat.id, s, '', 'Input Channels', InputChannels, '');
            self.setOptionValX(dat.id, s, '', 'Enclosure Entry', EnclosureEntry, '');
            self.setOptionValX(dat.id, s, '', 'Enclosure Exit', EnclosureExit, '');
            self.setOptionValX(dat.id, s, '', 'Stack Light', StackLight, '');
            return self.reCalcOutput(dat.id, s, p, '', '', '', '');

        });

    }
    else if (_val.startsWith('PXD')) {
        let Material = '';
        let PXD = '';
        let TypeofPD = '';
        let CompatPP = '';
        let InputChannels = '';
        let EnclosureEntry = '';
        let EnclosureExit = '';
        let PreStackLight = '';
        let StackLight = '';

        let arval = val.split('-');
        try {
            PXD = arval[0];
            Material = arval[0].charAt(3);
            TypeofPD = '1';// arval[0].charAt(4);
            CompatPP = '1';
            InputChannels = arval[0].charAt(5);

            EnclosureEntry = arval[1].charAt(0);
            EnclosureExit = arval[1].charAt(1);
            StackLight = arval[2] || '';
            //if (StackLight == '_') PreStackLight = '0';

        }
        catch {

        }


        self.setState((s, p) => {
            self.setOptionValX(dat.id, s, '', 'Type of Prox Driver', TypeofPD, '');
            self.setOptionValX(dat.id, s, '', 'Compatible Prox Probe', CompatPP, '');
            self.setOptionValX(dat.id, s, '', 'Material', Material, '');
            self.setOptionValX(dat.id, s, '', 'Input Channels', InputChannels, '');
            self.setOptionValX(dat.id, s, '', 'Enclosure Entry', EnclosureEntry, '');
            self.setOptionValX(dat.id, s, '', 'Enclosure Exit', EnclosureExit, '');
            self.setOptionValX(dat.id, s, '', 'Stack Light', StackLight, '');
            //'self.setOptionValX(dat.id, s, '', 'Pre Stack Light', PreStackLight, '');
            return self.reCalcOutput(dat.id, s, p, '', '', '', '');

        });

    }
    else if (_val.startsWith('MVR')) {
        var Channels = '';

        var Entry = '';
        var Exit = '';
        let arval = val.split('-');
        try {
            Channels = arval[1].charAt(0);
            Output = arval[2].charAt(0);
            Entry = arval[3].charAt(0);
            Exit = arval[3].charAt(1);

        }
        catch {

        }


        self.setState((s, p) => {
            self.setOptionValX(dat.id, s, '', 'Channels', Channels, '');
            self.setOptionValX(dat.id, s, '', 'Output', Output, '');
            self.setOptionValX(dat.id, s, '', 'Entry', Entry, '');
            self.setOptionValX(dat.id, s, '', 'Exit', Exit, '');
            return self.reCalcOutput(dat.id, s, p, '', '', '', '');

        });

    }
    else if (_val.startsWith('DM') && arvals[0].length == 6) {

        let rtn = parseDM_NPT(val);
        self.setState((s, p) => {
            self.setOptionValX(dat.id, s, '', 'DM SERIES', rtn.Part, '');
            self.setOptionValX(dat.id, s, '', 'PROX DIAMETER', rtn.PROXDIAMETER, '');
            self.setOptionValX(dat.id, s, '', 'FITTING THREADS', rtn.FITTINGTHREADS, '');
            self.setOptionValX(dat.id, s, '', 'ARMOR', rtn.ARMOR, '');
            self.setOptionValX(dat.id, s, '', 'CABLES', rtn.CABLES, '');
            self.setOptionValX(dat.id, s, '', 'HP LENGTH 1', rtn.HPLENGTH1, '');
            self.setOptionValX(dat.id, s, '', 'OVERALL LENGTH 1', rtn.OVERALLLENGTH1, '');
            self.setOptionValX(dat.id, s, '', 'HP LENGTH 2', rtn.HPLENGTH2, '');
            self.setOptionValX(dat.id, s, '', 'OVERALL LENGTH 2', rtn.OVERALLLENGTH2, '');
            self.setOptionValX(dat.id, s, '', 'HP LENGTH 3', rtn.HPLENGTH3, '');
            self.setOptionValX(dat.id, s, '', 'OVERALL LENGTH 3', rtn.OVERALLLENGTH3, '');
            self.setOptionValX(dat.id, s, '', 'CONNECTOR PROTECTOR', rtn.CONNECTORPROTECTOR, '');
            self.setOptionValX(dat.id, s, '', 'HAZARD RATED', rtn.HAZARDRATED, '');
            return self.reCalcOutput(dat.id, s, p, '', '', '', '');
        });

    }
    else if (_val.startsWith('DM')) {

        var Part = '';

        var Mount = '';
        var ProbeOption = '';
        var CableLengthOption = '';
        var StandoffAdapter = '';
        var PenetrationDepth = '';
        var FittingOption = '';
        var Face1FittingOption = '';
        var Face2FittingOption = '';
        var Face3FittingOption = '';
        var MountingOption = '';

        let arval = val.split('-');

        try {
            Part = arval[0];

            if (Part == "DM91000") {
                Mount = arval[0];
                ProbeOption = arval[1];
                CableLengthOption = arval[2];
                StandoffAdapter = arval[3];
                PenetrationDepth = arval[4];
                FittingOption = arval[5];
                MountingOption = arval[6];
            } else {

                Mount = val;
            }


        }
        catch {

        }

        try {
            Part = arval[0];

            if (Part == "DM92000" || Part == "DM95000") {
                Mount = arval[0];
                //ProbeOption = arval[1];
                //CableLengthOption = arval[2];
                StandoffAdapter = arval[1];
                PenetrationDepth = arval[2];
                FittingOption = arval[3];
                //MountingOption = arval[6];
            } else if (Part.startsWith("DM7200")) {
                Mount = arval[0];
                StandoffAdapter = arval[1];
                PenetrationDepth = arval[2];
                Face1FittingOption = arval[3];
                Face2FittingOption = arval[4];
                Face3FittingOption = arval[5];
            } else {

                Mount = val;
            }


        }
        catch {

        }

        if (StandoffAdapter == "02") {
            PenetrationDepth = "_" + PenetrationDepth;
        }
        if (StandoffAdapter == "05") {
            PenetrationDepth = "#" + PenetrationDepth;
        }

        self.setState((s, p) => {
            self.setOptionValX(dat.id, s, '', 'Part', Part, '');
            self.setOptionValX(dat.id, s, '', 'Mount', Mount, '');


            self.setOptionValX(dat.id, s, '', 'Probe Option', ProbeOption, '');
            self.setOptionValX(dat.id, s, '', 'Cable Length Option', CableLengthOption, '');
            self.setOptionValX(dat.id, s, '', 'Standoff Adapter', StandoffAdapter, '');
            self.setOptionValX(dat.id, s, '', 'Penetration Depth', PenetrationDepth, '');
            self.setOptionValX(dat.id, s, '', 'Fitting Option', FittingOption, '');
            self.setOptionValX(dat.id, s, '', 'Fitting Option 1', Face1FittingOption, '');
            self.setOptionValX(dat.id, s, '', 'Fitting Option 2', Face2FittingOption, '');
            self.setOptionValX(dat.id, s, '', 'Fitting Option 3', Face3FittingOption, '');
            self.setOptionValX(dat.id, s, '', 'Mounting Option', MountingOption, '');

            return self.reCalcOutput(dat.id, s, p, '', '', '', '');

        });

    }
    else if (_val.startsWith("DT")) {
        var BasePart = ''
        var BracketType = '';
        let arval = val.split('-');

        try {
            BasePart = arval[0];
            if (BasePart == "DT902") {
                BracketType = arval[1];
            }
        }
        catch { }

        self.setState((s, p) => {
            self.setOptionValX(dat.id, s, '', "Part", BasePart, '');
            self.setOptionValX(dat.id, s, '', 'Bracket Type', BracketType, '');
            return self.reCalcOutput(dat.id, s, p, '', '', '', '');
        });
    }
    else if (_val.startsWith('DC')) {
        var ProxCable = '';
        var TotalLengthofExtensionCable = '';
        var CableType = '';
        var RegulatoryApproval = '';

        var AA = '';
        var CP = '';

        let arval = val.split('-');
        try {
            ProxCable = arval[0];
            TotalLengthofExtensionCable = arval[1];
            if (arval[2] == '03') {
                CableType = arval[2];
                AA = "1";
                CP = "1";
            }
            else if (arval[2] == '02') {
                CableType = arval[2];
                AA = "0";
                CP = "1";
            }
            else if (arval[2] == '01') {
                CableType = arval[2];
                AA = "1";
                CP = "0";
            }
            else if (arval[2] == '00') {
                CableType = arval[2];
                AA = "0";
                CP = "0";
            }
            else {

            }

            RegulatoryApproval = arval[3];

        }
        catch {

        }


        self.setState((s, p) => {
            self.setOptionValX(dat.id, s, '', 'Prox Cable', ProxCable, '');
            self.setOptionValX(dat.id, s, '', 'Total Length of Extension Cable', TotalLengthofExtensionCable, '');
            self.setOptionValX(dat.id, s, '', 'AA', AA, '');
            self.setOptionValX(dat.id, s, '', 'CP', CP, '');
            self.setOptionValX(dat.id, s, '', 'Regulatory Approval', RegulatoryApproval, '');
            return self.reCalcOutput(dat.id, s, p, '', '', '', '');

        });

    }
    else if (_val.startsWith('IS')) {
        //var BarrierSystem = '';
        //var NumberOfChannels = '';
        //var EnclosureExit = '';
        //var EnclosureEntry = '';


        //let arval = val.split('-');
        //try {
        //    BarrierSystem = arval[0];
        //    NumberOfChannels = arval[1].match(/\d+/g);
        //    EnclosureEntry = arval[2].charAt(0);
        //    EnclosureExit = arval[2].charAt(1);
        //}
        //catch {

        //}

        //self.setState((s, p) => {
        //    self.setOptionValX(dat.id, s, '', 'Barrier System', BarrierSystem, '');
        //    self.setOptionValX(dat.id, s, '', 'Number Of Channels', NumberOfChannels, '');
        //    self.setOptionValX(dat.id, s, '', 'Enclosure Entry', EnclosureEntry, '');
        //    self.setOptionValX(dat.id, s, '', 'Enclosure Exit', EnclosureExit, '');
        //    return self.reCalcOutput(dat.id, s, p, '', '', '', '');
        //    //self.setOptionValX(dat.id, s, '', 'Box size', 2, '');
        //});

    }
    else if (_val.startsWith('SC')) {
        var SC = '';
        var IEPEPower = '';
        var OutputType = '';
        var ISOFilter = '';

        let arval = val.split('-');
        try {
            SC = arval[0];
            IEPEPower = arval[1];
            OutputType = arval[2];
            ISOFilter = arval[3];
        }
        catch {

        }

        self.setState((s, p) => {
            self.setOptionValX(dat.id, s, '', 'SC', SC, '');
            self.setOptionValX(dat.id, s, '', 'IEPE Power', IEPEPower, '');
            self.setOptionValX(dat.id, s, '', 'Output Type', OutputType, '');
            self.setOptionValX(dat.id, s, '', 'ISO Filter', ISOFilter, '');

            return self.reCalcOutput(dat.id, s, p, '', '', '', '');
        });
    }
    else if (_val.startsWith('RXE') && _val.length == 14) {

        var RXE = '';
        var NumberOfSignalConditioners = '';
        var NumberOfRelays = '';
        var EntryFitting = '';
        var ExitFitting = '';


        let arval = val.split('-');
        try {
            RXE = arval[0];
            NumberOfSignalConditioners = arval[1];
            NumberOfRelays = arval[2];
            EntryFitting = arval[3].charAt(0);
            ExitFitting = arval[3].charAt(1);

        }
        catch {

        }


        self.setState((s, p) => {
            self.setOptionValX(dat.id, s, '', 'RXE', RXE, '');
            self.setOptionValX(dat.id, s, '', 'Number Of Signal Conditioners', NumberOfSignalConditioners, '');
            self.setOptionValX(dat.id, s, '', 'Number Of Relays', NumberOfRelays, '');
            self.setOptionValX(dat.id, s, '', 'Entry Fitting', EntryFitting, '');
            self.setOptionValX(dat.id, s, '', 'Exit Fitting', ExitFitting, '');
            return self.reCalcOutput(dat.id, s, p, '', '', '', '');

        });

    }
    else if (_val.startsWith('PMX')) {
        var EnclosureType = '';
        var LPType = '';
        var Channels = '';
        var DisplayType = '';
        var EntryFitting = '';
        var ExitFitting = '';
        var StackLight = '_';
        var Output = '';

        let arval = val.split('-');
        try {
            EnclosureType = arval[0].substring(0, 4);
            LPType = arval[0].substr(4, 1)
            Channels = arval[0].substr(5, 1)

            //DisplayType = arval[1].match(/[a-zA-Z]/g);

            EntryFitting = arval[1].charAt(0);
            ExitFitting = arval[1].charAt(1);

            StackLight = arval[2] || '_';
        }
        catch {

        }

        self.setState((s, p) => {
            self.setOptionValX(dat.id, s, '', 'Enclosure Type', EnclosureType, '');
            self.setOptionValX(dat.id, s, '', 'Channels', Channels, '');
            self.setOptionValX(dat.id, s, '', 'LP Type', LPType, '');
            self.setOptionValX(dat.id, s, '', 'Entry Fitting', EntryFitting, '');
            self.setOptionValX(dat.id, s, '', 'Exit Fitting', ExitFitting, '');
            self.setOptionValX(dat.id, s, '', 'Stack Light', StackLight, '');

            return self.reCalcOutput(dat.id, s, p, '', '', '', '');
        });
    }
    else if (_val.startsWith('MVR') || _val.startsWith('RXE')) {

        var EnclosureType = '';
        var Channels = '';
        var DisplayType = '';
        var EntryFitting = '';
        var ExitFitting = '';
        var StackLight = '_';

        var Output = '';

        let arval = val.split('-');
        try {
            if (_val.startsWith('RXE')) {
                EnclosureType = arval[0];
                Channels = arval[1].match(/\d+/g);
                DisplayType = arval[1].match(/[a-zA-Z]/g);
                EntryFitting = arval[2].charAt(0);
                ExitFitting = arval[2].charAt(1);
                StackLight = arval[3] || '_';
            }
            else if (_val.startsWith('MVR')) {
                EnclosureType = arval[0];
                Channels = arval[1].match(/\d+/g);
                Output = arval[2].match(/[a-zA-Z]/g);
                EntryFitting = arval[3].charAt(0);
                ExitFitting = arval[3].charAt(1);
            }
        }
        catch {

        }

        
        self.setState((s, p) => {
            self.setOptionValX(dat.id, s, '', 'Enclosure Type', EnclosureType, '');
            self.setOptionValX(dat.id, s, '', 'Channels', Channels, '');
            self.setOptionValX(dat.id, s, '', 'Display Type', DisplayType, '');
            self.setOptionValX(dat.id, s, '', 'Entry Fitting', EntryFitting, '');
            self.setOptionValX(dat.id, s, '', 'Exit Fitting', ExitFitting, '');
            self.setOptionValX(dat.id, s, '', 'Stack Light', StackLight, '');

            return self.reCalcOutput(dat.id, s, p, '', '', '', '');

        });

    }

    else if (_val.startsWith('PM')) {
        var Input = '';
        var Output = '';
        let arval = val.split('-');
        try {
            Input = arval[2].charAt(0);
            Output = arval[2].charAt(1);

        }
        catch {

        }


        self.setState((s, p) => {
            self.setOptionValX(dat.id, s, '', 'Input', Input, '');
            self.setOptionValX(dat.id, s, '', 'Output', Output, '');
            return self.reCalcOutput(dat.id, s, p, '', '', '', '');

        });

    }
    else if (_val.startsWith('PD') || _val.startsWith('RE')) {
        var Relay = '';
        var Option = '';

        let arval = val.split('-');
        try {
            Relay = arval[0];
            Option = arval[1];

        }
        catch {

        }


        self.setState((s, p) => {
            self.setOptionValX(dat.id, s, '', 'Relay', Relay, '');
            self.setOptionValX(dat.id, s, '', 'Option', Option, '');

            return self.reCalcOutput(dat.id, s, p, '', '', '', '');

        });

    }
    else if (_val.startsWith('VN')) {
        var Base = '';
        var Reach = '';
        var Sensor = '';

        let arval = val.split('-');
        try {
            Base = arval[0];
            let x = arval[1];
            Reach = x.substring(0,x.length - 1);
            Sensor = x.substring(x.length - 1);       
        }
        catch {

        }


        self.setState((s, p) => {
            self.setOptionValX(dat.id, s, '', 'BASE', Base, '');
            self.setOptionValX(dat.id, s, '', 'REACH', Reach, '');
            self.setOptionValX(dat.id, s, '', 'SENSOR', Sensor, '');

            return self.reCalcOutput(dat.id, s, p, '', '', '', '');

        });

    }

    else if (_val.startsWith('WS') && arvals[1].includes("PK")) {
        //#region USB Script
        let OTH = val;

        self.setState((s, p) => {

            self.setOptionValX(dat.id, s, '', 'Part Number', OTH, '');

            return self.reCalcOutput(dat.id, s, p, '', '', '', '');
        });
        //#endregion
    }

    else if (_val.startsWith('WSK')) {

        let arval = val.split('-');
        var WSK = '';
        var SE1 = '';
        var SE2 = '';
        var ST = '';

        try {
            WSK = 'WSK';
            SE1 = val.substr(3,2);
            //SE2 = arval[0][4];
            ST = arval[1];
        }
        catch {

        }

        self.setState((s, p) => {
            self.setOptionValX(dat.id, s, '', '', WSK, '', 'WSK');
            self.setOptionValX(dat.id, s, '', '', SE1, '', 'SE1');
            //self.setOptionValX(dat.id, s, '', '', SE2, '', 'SE2');
            self.setOptionValX(dat.id, s, '', '', ST, '', 'ST');

            return self.reCalcOutput(dat.id, s, p, '', '', '', '');
        });

    }

    else if (_val.startsWith('WS')) {

        var StudType = "_";
        let arval = val.split('/');
        
        if (arval[0] == "M" || arval[0] == "P25" || arval[0] == "M8") {
            StudType = arval[0];
            val = val.substring(val.indexOf('/') + 1);
            //arval = val.split('/');
            //arval2 = val.split('-');
        }

        var WS = '';
        var ISO = '';
        var OU = ''; 
        var DR = ''; 
        var FR = ''; 
        var SR = ''; 
        var NS = ''; 
        var AR = '';

        arval = val.split('-');
        try {
            WS = arval[0];

            if (WS == 'WS101')
            {
                let x = arval[1];
                OU = x.substring(0, 1);
                DR = x.substring(x.length - 1);

                FR = arval[2];

                AR = arval[3];

                ISO = '2'
            }
            else
            {
                let x = arval[1];
                DR = x.substring(0, 1);
                SR = x.substring(1,2);
                NS = x.substring(x.length - 1);

                AR = arval[2];
            }
        }
        catch {

        }


        self.setState((s, p) => {
            self.setOptionValX(dat.id, s, '', 'WS', WS, '');
            self.setOptionValX(dat.id, s, '', 'ISO', ISO, '');
            self.setOptionValX(dat.id, s, '', 'OU', OU, '');
            self.setOptionValX(dat.id, s, '', 'DR', DR, '');
            self.setOptionValX(dat.id, s, '', 'FR', FR, '');
            self.setOptionValX(dat.id, s, '', 'SR', SR, '');
            self.setOptionValX(dat.id, s, '', 'NS', NS, '');
            self.setOptionValX(dat.id, s, '', 'AR', AR, '');
            self.setOptionValX(dat.id, s, '', 'ST', StudType, '');

            return self.reCalcOutput(dat.id, s, p, '', '', '', '');

        });

    }

    //default parsing
    else { }

    return noprofile;
}

export function parseDM_NPT(val)
{
    let rtn = {};
    rtn.Part = "DM";
    rtn.PROXDIAMETER = '';
    rtn.FITTINGTHREADS = '';
    rtn.ARMOR = '';
    rtn.CABLES = '';
    rtn.HPLENGTH1 = '';
    rtn.OVERALLLENGTH1 = '';
    rtn.HPLENGTH2 = '';
    rtn.OVERALLLENGTH2 = '';
    rtn.HPLENGTH3 = '';
    rtn.OVERALLLENGTH3 = '';
    rtn.CONNECTORPROTECTOR = '';
    rtn.HAZARDRATED = '';

    let arval = val.split('-');
    try {
        rtn.Part = "DM";
        rtn.PROXDIAMETER = arval[0][5];
        rtn.FITTINGTHREADS = arval[0][2];
        rtn.ARMOR = arval[0][4];
        rtn.CABLES = arval[0][3];
        if (rtn.CABLES > 0) {
            rtn.HPLENGTH1 = arval[1];
            rtn.OVERALLLENGTH1 = arval[2];
        }
        if (rtn.CABLES > 1) {
            rtn.HPLENGTH2 = arval[3];
            rtn.OVERALLLENGTH2 = arval[4];
        }
        if (rtn.CABLES > 2) {
            rtn.HPLENGTH3 = arval[5];
            rtn.OVERALLLENGTH3 = arval[6];
        }
        rtn.CONNECTORPROTECTOR = arval[arval.length - 2];
        rtn.HAZARDRATED = arval[arval.length - 1];
    }
    catch {

    }
    return rtn;
}

export function addToCart(partnum, qty, id, parent, _parts)
{
    let p = partnum + ":" + qty + ":" + id + ":" + parent;
    _parts.push(p);

    let arx_partnum = partnum.split('-');

    // Check for special conditions
    // if the part is DM and has a first segment of 6 characters
    // This is out NPT Probe Pressure Fiting, Find the Cables to add to the order.
    if (partnum.startsWith('DM') && arx_partnum[0].length == 6) {
        let rtn = parseDM_NPT(partnum);


        let armor = rtn.ARMOR;
        let conprotect = rtn.CONNECTORPROTECTOR;
        if (parseInt(rtn.HAZARDRATED) > 0) conprotect = '02'

        if (armor != '0' && conprotect == '00') conprotect = "01";
        if (armor != '0' && conprotect == '02') conprotect = "03";

        let dcBase = '';
        dcBase = rtn.PROXDIAMETER == '1' ? "DC100130-0" : dcBase;
        dcBase = rtn.PROXDIAMETER == '7' ? "DC100730-0" : dcBase;
        dcBase = rtn.PROXDIAMETER == '8' ? "DC100854-0" : dcBase;
        dcBase = rtn.PROXDIAMETER == '9' ? "DC100930-0" : dcBase;

        let rating = parseInt(rtn.HAZARDRATED)+20;
        let _c1 = dcBase + rtn.OVERALLLENGTH1 + '-' + conprotect + '-' + rating;
        let _c2 = dcBase + rtn.OVERALLLENGTH2 + '-' + conprotect + '-' + rating;
        let _c3 = dcBase + rtn.OVERALLLENGTH3 + '-' + conprotect + '-' + rating;

        let cablect = rtn.CABLES;
        if (cablect > 0) {
            let newid = uuidv4();
            let c1 = _c1 + ":" + qty + ":" + newid + ":" + id;
            _parts.push(c1);
        }
        if (cablect > 1) {
            let newid = uuidv4();
            let c2 = _c2 + ":" + qty + ":" + newid + ":" + id;
            _parts.push(c2);
        }
        if (cablect > 2) {
            let newid = uuidv4();
            let c3 = _c3 + ":" + qty + ":" + newid + ":" + id;
            _parts.push(c3);
        }
    }
}

async function setCategory(self, cat) {
    let _cat = self.state.profiles.filter(x => x.name == cat)[0];
    if (_cat && !_cat.archive) {
        let pid = _cat.id;
        await self.setProfile(pid, {
            id: ''
        }, true, '', 0, null);
        return false;
    }
    return true;
}

function uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}